<template>
  <div>
    <ResultBox />
    <div class="banner">
      <img src="@/assets/images/banner1.jpg">
    </div>
    <div class="news">
      <iframe src="https://m.baomoi.com/chung-khoan.epi" class="iframe-1" scrolling="no"></iframe>
    </div>
  </div>
</template>
<script>
import ResultBox from './components/ResultBox.vue'

export default {
  components: {
    ResultBox
  },
  data() {
    return {
      currentDate: null
    }
  },
  created() {
    console.log('pathDate', this.$route.params.pathDate)
  }
}
</script>
<style lang="scss">
.my-result {
  height: 450px;
  margin-bottom: 10px;
}
.banner {
  margin-top: 10px;
  img {
    width: 100%;
  }
}

.news {
  overflow: hidden;
  margin-top: 10px;

  .iframe-1 {
    border: 0;
    height: 1550px;
    margin-top: -120px;
    pointer-events: none;
    overflow: hidden;
  }
}
</style>
